import React, { useState } from 'react';
import { FlagPair } from './FlagPair';

export type ContribEntry = {
  id: number | string;
  name: string;
  title: string;
  cc1: string;
  cc2: string | null;
  country1: string;
  country2: string | null;
  photo_url: string | null;
  tier: string;
};

function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(s => s[0]?.toUpperCase() ?? '')
    .join('');
}

export function ChiefCard({ chief }: { chief: ContribEntry }) {
  const [errored, setErrored] = useState(false);
  const showInitials = !chief.photo_url || errored;

  const pairLabel = chief.cc2
    ? `${chief.country1} · ${chief.country2}`
    : chief.country1;

  return (
    <article
      style={{
        flex: '0 0 220px',
        scrollSnapAlign: 'start',
        textAlign: 'center',
        padding: 'var(--space-md)',
        background: 'rgba(20, 28, 48, 0.3)',
        border: '1px solid var(--color-border)',
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      <div
        style={{
          width: 88,
          height: 88,
          borderRadius: '50%',
          marginBottom: 'var(--space-md)',
          background: 'rgba(184, 155, 100, 0.12)',
          border: '1px solid var(--color-accent-dim)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          color: 'var(--color-accent)',
          fontFamily: 'var(--font-display)',
          fontSize: 24
        }}
      >
        {showInitials ? (
          initials(chief.name)
        ) : (
          <img
            src={chief.photo_url!}
            alt=""
            loading="lazy"
            decoding="async"
            onError={() => setErrored(true)}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        )}
      </div>
      <div style={{ fontSize: 14, fontWeight: 500, lineHeight: 1.3, marginBottom: 4 }}>
        {chief.name}
      </div>
      <div
        style={{
          fontSize: 12,
          color: 'var(--color-muted)',
          lineHeight: 1.4,
          marginBottom: 10,
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          minHeight: 32
        }}
      >
        {chief.title || '—'}
      </div>
      <FlagPair cc1={chief.cc1} cc2={chief.cc2} height={14} />
      <div
        style={{
          fontSize: 11,
          color: 'var(--color-text)',
          marginTop: 6,
          letterSpacing: '0.02em',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: '100%'
        }}
      >
        {pairLabel}
      </div>
    </article>
  );
}
